<p-dialog
  *ngIf="topic"
  [appendTo]="'body'"
  [(visible)]="detailsControl.isOpen"
  [position]="'right'"
  [style]="{ width: '55vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  (visibleChange)="hideDialog()"
>
  <div class="flex justify-content-between align-items-center mt-2">
    <div class="flex gap-2 align-items-center">
      <button class="secondary-button p-0 mr-2" (click)="hideDialog()" data-clarity-unmask="true">
        X
      </button>
    </div>
  </div>

  <ng-template pTemplate="content">
    <div
      class="flex flex-column md:flex-row justify-content-between align-content-center mt-3 md:mt-5 gap-1 md:gap-3 mb-3"
    >
      <div class="font-semibold text-xl">{{ topic.slideTitle }}</div>
      <div
        *ngIf="topic.created"
        class="flex justify-content-start md:justify-content-center align-items-center text-sm text-400"
      >
        Edytowano: {{ topic.created | date : "dd.MM.yyyy HH:mm" }}
      </div>
    </div>

    <p-tabView>
      <p-tabPanel header="Dane podstawowe">
        <form [formGroup]="contentForm">
          <div
            class="form-decorator flex w-full justify-content-left align-items-center mb-6"
          >
            <div class="title">Przypisany rozdział wykładu</div>
            <div class="w-full">
              <div
                *ngIf="!detailsControl.isEditing"
                class="flex align-items-center"
              >
                <input
                  type="text"
                  class="default-input input-off w-full flex-1"
                  [value]="topic.elearningTopicName || 'Brak rozdziału'"
                  readonly
                />
              </div>

              <div *ngIf="detailsControl.isEditing" class="w-full">
                <p-dropdown
                  id="elearningTopicId"
                  formControlName="elearningTopicId"
                  [options]="availableTopics"
                  optionValue="id"
                  optionLabel="name"
                  placeholder="Wybierz rozdział"
                  class="w-full"
                  styleClass="w-full"
                ></p-dropdown>
              </div>
            </div>
          </div>

          <div
            class="form-decorator flex w-full justify-content-left align-items-center mb-6"
          >
            <div class="title">Kategorie egzaminów (opcjonalnie)</div>
            <div class="w-full">
              <div
                *ngIf="!detailsControl.isEditing"
                class="flex align-items-center"
              >
                <input
                  type="text"
                  class="default-input input-off w-full flex-1"
                  [value]="
                    topic.examCategories && topic.examCategories.length > 0
                      ? getExamCategoryNames()
                      : 'Widoczny dla wszystkich kategorii działu'
                  "
                  readonly
                />
              </div>

              <div *ngIf="detailsControl.isEditing" class="w-full">
                <p-multiSelect
                  [appendTo]="'body'"
                  id="examsGuid"
                  formControlName="examsGuid"
                  [options]="availableExamsForCurrentTopic"
                  optionLabel="examName"
                  optionValue="guid"
                  placeholder="Widoczny dla wszystkich kategorii działu"
                  styleClass="custom-multiselect w-full"
                  class="w-full"
                  [disabled]="availableExamsForCurrentTopic.length === 0"
                  [showToggleAll]="false"
                  [filter]="false"
                  [maxSelectedLabels]="10"
                >
                </p-multiSelect>
              </div>
            </div>
          </div>

          <div
            class="form-decorator top-decorator flex w-full justify-content-left align-items-center"
          >
            <div class="title">Domyślny tytuł slajdu (PL)</div>
            <div class="w-full">
              <div
                *ngIf="!detailsControl.isEditing"
                class="flex align-items-center"
              >
                <input
                  type="text"
                  class="default-input input-off w-full flex-1"
                  [value]="topic.slideTitle"
                  readonly
                />
              </div>

              <div *ngIf="detailsControl.isEditing">
                <div class="flex align-items-center gap-2">
                  <input
                    type="text"
                    class="default-input w-full flex-1"
                    formControlName="slideTitle"
                    placeholder="Wprowadź tytuł slajdu"
                    [class.input-error]="
                      contentForm.get('slideTitle')?.invalid &&
                      contentForm.get('slideTitle')?.touched
                    "
                  />
                </div>

                <div
                  *ngIf="
                    contentForm.get('slideTitle')?.invalid &&
                    contentForm.get('slideTitle')?.touched
                  "
                  class="error-message mt-1"
                >
                  Tytuł slajdu jest wymagany.
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-decorator flex w-full justify-content-left align-items-center"
          >
            <div class="title">Domyślna treść slajdu (PL)</div>
            <div class="w-full">
              <div
                *ngIf="!detailsControl.isEditing"
                class="flex align-items-center"
              >
                <textarea
                  class="default-input flex input-off w-full"
                  [value]="topic.slideContent"
                  readonly
                  rows="8"
                ></textarea>
              </div>

              <div *ngIf="detailsControl.isEditing">
                <div class="flex align-items-center gap-2">
                  <textarea
                    class="default-input w-full"
                    formControlName="slideContent"
                    placeholder="Wprowadź treść slajdu"
                    rows="8"
                    [class.input-error]="
                      contentForm.get('slideContent')?.invalid &&
                      contentForm.get('slideContent')?.touched
                    "
                  ></textarea>
                </div>

                <div
                  *ngIf="
                    contentForm.get('slideContent')?.invalid &&
                    contentForm.get('slideContent')?.touched
                  "
                  class="error-message mt-1"
                >
                  Treść slajdu jest wymagana.
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-decorator flex w-full justify-content-left align-items-center"
          >
            <div class="title">Kolejność slajdu</div>
            <div class="w-full">
              <div
                *ngIf="!detailsControl.isEditing"
                class="flex align-items-center"
              >
                <input
                  type="text"
                  class="default-input input-off w-full flex-1"
                  [value]="topic.slideOrder || 0"
                  readonly
                />
              </div>

              <div *ngIf="detailsControl.isEditing" class="w-full">
                <input
                  type="number"
                  class="default-input w-full"
                  formControlName="slideOrder"
                  placeholder="0"
                  min="0"
                />
              </div>
            </div>
          </div>
        </form>

        <div
          class="mt-7 mb-3 text-gray-500 gap-2 flex justify-content-start align-items-center"
        >
          Media domyślne (PL)
        </div>

        <div
          class="form-decorator top-decorator flex w-full justify-content-left align-items-center"
        >
          <div
            class="title flex justify-content-start align-items-center gap-2"
          >
            <i class="pi pi-image"></i> Plik graficzny
          </div>
          <div class="w-full">
            <div
              *ngIf="!editingImageLink"
              class="flex justify-content-between align-items-center"
            >
              <img
                *ngIf="topic.imageLink; else noimg"
                [src]="
                  environment.webApiUrl +
                  topic.imageLink.replace('/media', '/uploadMedia')
                "
                alt="Thumbnail"
                width="200"
              />

              <ng-template #noimg>
                <span class="text-sm text-400">Brak pliku graficznego</span>
              </ng-template>

              <div class="flex gap-2">
                <button
                  type="button"
                  class="transparent-button"
                  [disabled]="shouldDisableButton()"
                  (click)="enableImageLinkEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-pencil"></i>
                </button>
                
                <button
                  *ngIf="topic.imageLink"
                  type="button"
                  class="transparent-button text-red-500"
                  [disabled]="savingImageLink || detailsControl.isEditing || isAnyTranslationBeingEdited()"
                  (click)="removeImageLink()"
                  title="Usuń obraz"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-spin pi-spinner" *ngIf="savingImageLink"></i>
                  <i class="pi pi-trash" *ngIf="!savingImageLink"></i>
                </button>
              </div>
            </div>

            <div *ngIf="editingImageLink">
              <div class="mb-3">
                <fas-services-upload
                  [environment]="environment.webApiUrl"
                  [allowedExtensions]="['.png', '.jpg', '.jpeg', 'webp']"
                  [mainIcon]="'pi-image'"
                  [multiple]="false"
                  (fileSelected)="onImageFileSelected($event)"
                >
                </fas-services-upload>
              </div>

              <div class="flex gap-2">
                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Zapisz obraz"
                  [disabled]="savingImageLink || !selectedImageFile"
                  (click)="saveImageLink()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-check" *ngIf="!savingImageLink"></i>
                  <i class="pi pi-spin pi-spinner" *ngIf="savingImageLink"></i>
                </button>

                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Anuluj edycję obrazu"
                  [disabled]="savingImageLink"
                  (click)="cancelImageLinkEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="form-decorator flex w-full justify-content-left align-items-center"
        >
          <div
            class="title flex justify-content-start align-items-center gap-2"
          >
            <i class="pi pi-video"></i> Plik wideo
          </div>
          <div class="w-full">
            <div
              *ngIf="!editingMediaLink"
              class="flex justify-content-between align-items-center gap-2"
            >
              <video
                controls
                *ngIf="topic.mediaLink; else nomedia"
                alt="Thumbnail"
                width="200"
              >
                <source
                  [src]="
                    environment.webApiUrl +
                    topic.mediaLink.replace('/media', '/uploadMedia')
                  "
                  type="video/mp4"
                />
              </video>

              <ng-template #nomedia>
                <span class="text-sm text-400">Brak video</span>
              </ng-template>

              <div class="flex gap-2">
                <button
                  type="button"
                  class="transparent-button"
                  [disabled]="detailsControl.isEditing || isAnyTranslationBeingEdited()"
                  (click)="enableMediaLinkEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-pencil"></i>
                </button>
                
                <button
                  *ngIf="topic.mediaLink"
                  type="button"
                  class="transparent-button text-red-500"
                  [disabled]="savingMediaLink || detailsControl.isEditing || isAnyTranslationBeingEdited()"
                  (click)="removeMediaLink()"
                  title="Usuń video"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-spin pi-spinner" *ngIf="savingMediaLink"></i>
                  <i class="pi pi-trash" *ngIf="!savingMediaLink"></i>
                </button>
              </div>
            </div>

            <div *ngIf="editingMediaLink">
              <div class="mb-3">
                <fas-services-upload
                  [environment]="environment.webApiUrl"
                  [allowedExtensions]="['.mp4', '.avi', '.mov', '.webm']"
                  [mainIcon]="'pi-video'"
                  [multiple]="false"
                  (fileSelected)="onMediaFileSelected($event)"
                >
                </fas-services-upload>
              </div>

              <div class="flex gap-2">
                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Zapisz media"
                  [disabled]="savingMediaLink || !selectedMediaFile"
                  (click)="saveMediaLink()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-check" *ngIf="!savingMediaLink"></i>
                  <i class="pi pi-spin pi-spinner" *ngIf="savingMediaLink"></i>
                </button>

                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Anuluj edycję mediów"
                  [disabled]="savingMediaLink"
                  (click)="cancelMediaLinkEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="form-decorator flex w-full justify-content-left align-items-center"
        >
          <div
            class="title flex justify-content-start align-items-center gap-2"
          >
            <i class="pi pi-volume-up"></i> Plik audio
          </div>
          <div class="w-full">
            <div
              *ngIf="!editingAudioLink"
              class="flex justify-content-between align-items-center gap-2"
            >
              <audio
                controls
                *ngIf="topic.audioLink; else noaudio"
                class="w-full flex-1"
              >
                <source
                  [src]="
                    environment.webApiUrl +
                    topic.audioLink.replace('/media', '/uploadMedia')
                  "
                  type="audio/mpeg"
                />
              </audio>

              <ng-template #noaudio>
                <span class="text-sm text-400">Brak audio</span>
              </ng-template>

              <div class="flex gap-2">
                <button
                  type="button"
                  class="transparent-button"
                  [disabled]="detailsControl.isEditing || isAnyTranslationBeingEdited()"
                  (click)="enableAudioLinkEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-pencil"></i>
                </button>
                
                <button
                  *ngIf="topic.audioLink"
                  type="button"
                  class="transparent-button text-red-500"
                  [disabled]="savingAudioLink || detailsControl.isEditing || isAnyTranslationBeingEdited()"
                  (click)="removeAudioLink()"
                  title="Usuń audio"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-spin pi-spinner" *ngIf="savingAudioLink"></i>
                  <i class="pi pi-trash" *ngIf="!savingAudioLink"></i>
                </button>
              </div>
            </div>

            <div *ngIf="editingAudioLink">
              <div class="mb-3">
                <fas-services-upload
                  [environment]="environment.webApiUrl"
                  [allowedExtensions]="['.mp3', '.wav', '.ogg']"
                  [mainIcon]="'pi-volume-up'"
                  [multiple]="false"
                  (fileSelected)="onAudioFileSelected($event)"
                >
                </fas-services-upload>
              </div>

              <div class="flex gap-2">
                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Zapisz audio"
                  [disabled]="savingAudioLink || !selectedAudioFile"
                  (click)="saveAudioLink()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-check" *ngIf="!savingAudioLink"></i>
                  <i class="pi pi-spin pi-spinner" *ngIf="savingAudioLink"></i>
                </button>

                <button
                  type="button"
                  class="transparent-button"
                  pTooltip="Anuluj edycję audio"
                  [disabled]="savingAudioLink"
                  (click)="cancelAudioLinkEditing()"
                  data-clarity-unmask="true"
                >
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Wersje językowe">
        <div class="mt-3">
          <div *ngFor="let language of availableLanguages" class="mb-6">
            <div *ngIf="!language.isDefault">
              <details class="translation-card">
                <summary
                  class="translation-summary cursor-pointer flex justify-content-between align-items-center text-gray-500"
                >
                  <div>
                    <i class="pi pi-flag mr-2"></i>Wersja językowa:
                    {{ language.name }} ({{ language.code.toUpperCase() }})
                  </div>
                  <i class="pi pi-angle-down"></i>
                </summary>

                <div class="translation-body p-3">
                  <div
                    class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center mb-4"
                  >
                    <div class="title">
                      Tytuł slajdu ({{ language.code.toUpperCase() }})
                    </div>
                    <div class="w-full">
                      <div
                        *ngIf="!editingTranslationSlideTitle[language.code]"
                        class="flex align-items-center"
                      >
                        <input
                          type="text"
                          class="default-input input-off w-full flex-1"
                          [value]="
                            getTranslationSlideTitle(language.code) ||
                            'Brak tłumaczenia tytułu'
                          "
                          readonly
                        />
                        <div class="flex gap-2">
                          <button
                              pTooltip="Edytuj tytuł tłumaczenia"
                            type="button"
                            class="transparent-button"
                            [disabled]="!canEditTranslationField(language.code, 'title')"
                            (click)="enableTranslationSlideTitleEditing(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-pencil"></i>
                          </button>
                          <button
                              pTooltip="Usuń tytuł tłumaczenia"
                            type="button"
                            class="transparent-button text-red-500"
                            *ngIf="getTranslationSlideTitle(language.code)"
                            [disabled]="!canEditTranslationField(language.code, 'title') || savingTranslationSlideTitle[language.code]"
                            (click)="deleteTranslationSlideTitle(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-spin pi-spinner" *ngIf="savingTranslationSlideTitle[language.code]"></i>
                            <i class="pi pi-trash" *ngIf="!savingTranslationSlideTitle[language.code]"></i>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="editingTranslationSlideTitle[language.code]">
                        <form
                          [formGroup]="translationSlideTitleForms[language.code]"
                          (ngSubmit)="saveTranslationSlideTitle(language.code)"
                        >
                          <div class="flex align-items-center gap-2">
                            <input
                              type="text"
                              class="default-input w-full flex-1"
                              formControlName="slideTitleOverride"
                              placeholder="Wprowadź tytuł tłumaczenia"
                              [class.input-error]="
                                translationSlideTitleForms[language.code].get('slideTitleOverride')
                                  ?.invalid &&
                                translationSlideTitleForms[language.code].get('slideTitleOverride')
                                  ?.touched
                              "
                            />
                            <div class="flex gap-2">
                              <button
                                type="submit"
                                class="transparent-button"
                                pTooltip="Zapisz tytuł tłumaczenia"
                                [disabled]="savingTranslationSlideTitle[language.code]"
                                data-clarity-unmask="true"
                              >
                                <i
                                  class="pi pi-check"
                                  *ngIf="!savingTranslationSlideTitle[language.code]"
                                ></i
                                ><i
                                  class="pi pi-spin pi-spinner"
                                  *ngIf="savingTranslationSlideTitle[language.code]"
                                ></i>
                              </button>
                              <button
                                type="button"
                                class="transparent-button"
                                pTooltip="Anuluj edycję tytułu tłumaczenia"
                                [disabled]="savingTranslationSlideTitle[language.code]"
                                (click)="cancelTranslationSlideTitleEditing(language.code)"
                                data-clarity-unmask="true"
                              >
                                <i class="pi pi-times"></i>
                              </button>
                            </div>
                          </div>
                          <div
                            *ngIf="
                              translationSlideTitleForms[language.code].get('slideTitleOverride')
                                ?.invalid &&
                              translationSlideTitleForms[language.code].get('slideTitleOverride')
                                ?.touched
                            "
                            class="error-message mt-1"
                          >
                            Tytuł tłumaczenia jest wymagany.
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-decorator flex w-full justify-content-left align-items-center mb-4"
                  >
                    <div class="title">
                      Treść slajdu ({{ language.code.toUpperCase() }})
                    </div>
                    <div class="w-full">
                      <div
                        *ngIf="!editingTranslationSlideContent[language.code]"
                        class="flex align-items-center gap-2"
                      >
                        <textarea
                          class="default-input input-off w-full flex-1"
                          [value]="
                            getTranslationSlideContent(language.code) ||
                            'Brak tłumaczenia treści'
                          "
                          readonly
                          rows="8"
                        ></textarea>
                        <div class="flex gap-2">
                          <button
                              pTooltip="Edytuj treść tłumaczenia"
                            type="button"
                            class="transparent-button"
                            [disabled]="!canEditTranslationField(language.code, 'content')"
                            (click)="enableTranslationSlideContentEditing(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-pencil"></i>
                          </button>
                          <button
                              pTooltip="Usuń treść tłumaczenia"
                            type="button"
                            class="transparent-button text-red-500"
                            *ngIf="getTranslationSlideContent(language.code)"
                            [disabled]="!canEditTranslationField(language.code, 'content') || savingTranslationSlideContent[language.code]"
                            (click)="deleteTranslationSlideContent(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-spin pi-spinner" *ngIf="savingTranslationSlideContent[language.code]"></i>
                            <i class="pi pi-trash" *ngIf="!savingTranslationSlideContent[language.code]"></i>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="editingTranslationSlideContent[language.code]">
                        <form
                          [formGroup]="translationSlideContentForms[language.code]"
                          (ngSubmit)="saveTranslationSlideContent(language.code)"
                        >
                          <div class="flex align-items-center gap-2">
                            <textarea
                              class="default-input w-full flex-1"
                              formControlName="slideContentOverride"
                              placeholder="Wprowadź treść tłumaczenia"
                              rows="8"
                              [class.input-error]="
                                translationSlideContentForms[language.code].get('slideContentOverride')
                                  ?.invalid &&
                                translationSlideContentForms[language.code].get('slideContentOverride')
                                  ?.touched
                              "
                            ></textarea>
                            <div class="flex gap-2">
                              <button
                                type="submit"
                                class="transparent-button"
                                pTooltip="Zapisz treść tłumaczenia"
                                [disabled]="savingTranslationSlideContent[language.code]"
                                data-clarity-unmask="true"
                              >
                                <i
                                  class="pi pi-check"
                                  *ngIf="!savingTranslationSlideContent[language.code]"
                                ></i
                                ><i
                                  class="pi pi-spin pi-spinner"
                                  *ngIf="savingTranslationSlideContent[language.code]"
                                ></i>
                              </button>
                              <button
                                type="button"
                                class="transparent-button"
                                pTooltip="Anuluj edycję treści tłumaczenia"
                                [disabled]="savingTranslationSlideContent[language.code]"
                                (click)="cancelTranslationSlideContentEditing(language.code)"
                                data-clarity-unmask="true"
                              >
                                <i class="pi pi-times"></i>
                              </button>
                            </div>
                          </div>
                          <div
                            *ngIf="
                              translationSlideContentForms[language.code].get('slideContentOverride')
                                ?.invalid &&
                              translationSlideContentForms[language.code].get('slideContentOverride')
                                ?.touched
                            "
                            class="error-message mt-1"
                          >
                            Treść tłumaczenia jest wymagana.
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-decorator flex w-full justify-content-left align-items-center mb-4"
                  >
                    <div class="title">
                      Plik graficzny ({{ language.code.toUpperCase() }})
                    </div>
                    <div class="w-full">
                      <div
                        *ngIf="!editingTranslationImageLink[language.code]"
                        class="flex justify-content-between align-items-center"
                      >
                        <img
                          *ngIf="getTranslationImageLink(language.code); else noTranslationImage"
                          [src]="
                            environment.webApiUrl +
                            getTranslationImageLink(language.code).replace(
                              '/media',
                              '/uploadMedia'
                            )
                          "
                          alt="Translation Image"
                          width="200"
                        />
                        <ng-template #noTranslationImage
                          ><span class="text-sm text-400"
                            >Brak pliku graficznego</span
                          ></ng-template
                        >
                        <div class="flex gap-2">
                          <button
                              pTooltip="Edytuj plik graficzny tłumaczenia"
                            type="button"
                            class="transparent-button"
                            [disabled]="!canEditTranslationField(language.code, 'image')"
                            (click)="enableTranslationImageLinkEditing(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-pencil"></i>
                          </button>
                          <button
                              pTooltip="Usuń plik graficzny tłumaczenia"
                            type="button"
                            class="transparent-button text-red-500"
                            *ngIf="getTranslationImageLink(language.code)"
                            [disabled]="!canEditTranslationField(language.code, 'image') || savingTranslationImageLink[language.code]"
                            (click)="deleteTranslationImageLink(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-spin pi-spinner" *ngIf="savingTranslationImageLink[language.code]"></i>
                            <i class="pi pi-trash" *ngIf="!savingTranslationImageLink[language.code]"></i>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="editingTranslationImageLink[language.code]">
                        <div class="mb-3">
                          <fas-services-upload
                            [environment]="environment.webApiUrl"
                            [allowedExtensions]="['.png', '.jpg', '.jpeg', 'webp']"
                            [mainIcon]="'pi-image'"
                            [multiple]="false"
                            (fileSelected)="onTranslationImageSelected($event, language.code)"
                          ></fas-services-upload>
                        </div>
                        <div class="flex gap-2">
                          <button
                            type="button"
                            class="transparent-button"
                            pTooltip="Zapisz obraz tłumaczenia"
                            [disabled]="
                              savingTranslationImageLink[language.code] ||
                              !selectedTranslationImageFiles[language.code]
                            "
                            (click)="saveTranslationImageLink(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i
                              class="pi pi-check"
                              *ngIf="!savingTranslationImageLink[language.code]"
                            ></i
                            ><i
                              class="pi pi-spin pi-spinner"
                              *ngIf="savingTranslationImageLink[language.code]"
                            ></i>
                          </button>
                          <button
                            type="button"
                            class="transparent-button"
                            pTooltip="Anuluj edycję obrazu tłumaczenia"
                            [disabled]="savingTranslationImageLink[language.code]"
                            (click)="cancelTranslationImageLinkEditing(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-decorator flex w-full justify-content-left align-items-center mb-4"
                  >
                    <div class="title">
                      Plik wideo ({{ language.code.toUpperCase() }})
                    </div>
                    <div class="w-full">
                      <div
                        *ngIf="!editingTranslationMediaLink[language.code]"
                        class="flex justify-content-between align-items-center"
                      >
                        <video
                          controls
                          *ngIf="getTranslationMediaLink(language.code); else noTranslationMedia"
                          alt="Translation Media"
                          width="200"
                        >
                          <source
                            [src]="
                              environment.webApiUrl +
                              getTranslationMediaLink(language.code).replace(
                                '/media',
                                '/uploadMedia'
                              )
                            "
                            type="video/mp4"
                          />
                        </video>
                        <ng-template #noTranslationMedia
                          ><span class="text-sm text-400"
                            >Brak pliku wideo</span
                          ></ng-template
                        >
                        <div class="flex gap-2">
                          <button
                              pTooltip="Edytuj plik wideo tłumaczenia"
                            type="button"
                            class="transparent-button"
                            [disabled]="!canEditTranslationField(language.code, 'media')"
                            (click)="enableTranslationMediaLinkEditing(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-pencil"></i>
                          </button>
                          <button
                              pTooltip="Usuń plik wideo tłumaczenia"
                            type="button"
                            class="transparent-button text-red-500"
                            *ngIf="getTranslationMediaLink(language.code)"
                            [disabled]="!canEditTranslationField(language.code, 'media') || savingTranslationMediaLink[language.code]"
                            (click)="deleteTranslationMediaLink(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-spin pi-spinner" *ngIf="savingTranslationMediaLink[language.code]"></i>
                            <i class="pi pi-trash" *ngIf="!savingTranslationMediaLink[language.code]"></i>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="editingTranslationMediaLink[language.code]">
                        <div class="mb-3">
                          <fas-services-upload
                            [environment]="environment.webApiUrl"
                            [allowedExtensions]="['.mp4', '.avi', '.mov', '.webm']"
                            [mainIcon]="'pi-video'"
                            [multiple]="false"
                            (fileSelected)="onTranslationMediaSelected($event, language.code)"
                          ></fas-services-upload>
                        </div>
                        <div class="flex gap-2">
                          <button
                            type="button"
                            class="transparent-button"
                            pTooltip="Zapisz media tłumaczenia"
                            [disabled]="
                              savingTranslationMediaLink[language.code] ||
                              !selectedTranslationMediaFiles[language.code]
                            "
                            (click)="saveTranslationMediaLink(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i
                              class="pi pi-check"
                              *ngIf="!savingTranslationMediaLink[language.code]"
                            ></i
                            ><i
                              class="pi pi-spin pi-spinner"
                              *ngIf="savingTranslationMediaLink[language.code]"
                            ></i>
                          </button>
                          <button
                            type="button"
                            class="transparent-button"
                            pTooltip="Anuluj edycję mediów tłumaczenia"
                            [disabled]="savingTranslationMediaLink[language.code]"
                            (click)="cancelTranslationMediaLinkEditing(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-decorator flex w-full justify-content-left align-items-center"
                  >
                    <div class="title">
                      Plik audio ({{ language.code.toUpperCase() }})
                    </div>
                    <div class="w-full">
                      <div
                        *ngIf="!editingTranslationAudioLink[language.code]"
                        class="flex justify-content-between align-items-center"
                      >
                        <audio
                          controls
                          *ngIf="getTranslationAudioLink(language.code); else noTranslationAudio"
                          alt="Translation Audio"
                          class="w-full flex-1"
                        >
                          <source
                            [src]="
                              environment.webApiUrl +
                              getTranslationAudioLink(language.code).replace(
                                '/media',
                                '/uploadMedia'
                              )
                            "
                            type="audio/mpeg"
                          />
                        </audio>
                        <ng-template #noTranslationAudio
                          ><span class="text-sm text-400"
                            >Brak pliku audio</span
                          ></ng-template
                        >
                        <div class="flex gap-2">
                          <button
                              pTooltip="Edytuj plik audio tłumaczenia"
                            type="button"
                            class="transparent-button"
                            [disabled]="!canEditTranslationField(language.code, 'audio')"
                            (click)="enableTranslationAudioLinkEditing(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-pencil"></i>
                          </button>
                          <button
                              pTooltip="Usuń plik audio tłumaczenia"
                            type="button"
                            class="transparent-button text-red-500"
                            *ngIf="getTranslationAudioLink(language.code)"
                            [disabled]="!canEditTranslationField(language.code, 'audio') || savingTranslationAudioLink[language.code]"
                            (click)="deleteTranslationAudioLink(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-spin pi-spinner" *ngIf="savingTranslationAudioLink[language.code]"></i>
                            <i class="pi pi-trash" *ngIf="!savingTranslationAudioLink[language.code]"></i>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="editingTranslationAudioLink[language.code]">
                        <div class="mb-3">
                          <fas-services-upload
                            [environment]="environment.webApiUrl"
                            [allowedExtensions]="['.mp3', '.wav', '.ogg']"
                            [mainIcon]="'pi-volume-up'"
                            [multiple]="false"
                            (fileSelected)="onTranslationAudioSelected($event, language.code)"
                          ></fas-services-upload>
                        </div>
                        <div class="flex gap-2">
                          <button
                            type="button"
                            class="transparent-button"
                            pTooltip="Zapisz audio tłumaczenia"
                            [disabled]="
                              savingTranslationAudioLink[language.code] ||
                              !selectedTranslationAudioFiles[language.code]
                            "
                            (click)="saveTranslationAudioLink(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i
                              class="pi pi-check"
                              *ngIf="!savingTranslationAudioLink[language.code]"
                            ></i
                            ><i
                              class="pi pi-spin pi-spinner"
                              *ngIf="savingTranslationAudioLink[language.code]"
                            ></i>
                          </button>
                          <button
                            type="button"
                            class="transparent-button"
                            pTooltip="Anuluj edycję audio tłumaczenia"
                            [disabled]="savingTranslationAudioLink[language.code]"
                            (click)="cancelTranslationAudioLinkEditing(language.code)"
                            data-clarity-unmask="true"
                          >
                            <i class="pi pi-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </details>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex flex-wrap gap-2 w-full align-items-center justify-content-between mb-2">
      <div *ngIf="detailsControl.isEditing" class="flex gap-2">
        <p-button
          [disabled]="!contentForm.valid || isSaving"
          (onClick)="saveContent()"
          label="Zapisz zmiany"
          [icon]="isSaving ? 'pi pi-spin' : 'pi pi-save'"
          data-clarity-unmask="true"
        ></p-button>
        <p-button
          label="Anuluj"
          [link]="true"
          (onClick)="editToggle()"
          [disabled]="isSaving"
          data-clarity-unmask="true"
        >
        </p-button>
      </div>

      <div *ngIf="!detailsControl.isEditing">
        <p-button 
          label="Edytuj" 
          icon="pi pi-pencil" 
          (onClick)="editToggle()"
          [disabled]="isAnyTranslationBeingEdited()"
          [title]="isAnyTranslationBeingEdited() ? 'Zakończ edycję tłumaczenia przed rozpoczęciem edycji głównego formularza' : ''" data-clarity-unmask="true">
        </p-button>
      </div>

      <p-button icon="pi pi-trash" label="Usuń slajd" [outlined]="true" (onClick)="deleteTopicContent()" data-clarity-unmask="true">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
